import toast from "react-hot-toast";
import axios from "axios";
// import { token } from "../../Utils/helpers";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const user = localStorage.getItem("userInfo")
  ? JSON.parse(localStorage.getItem("userInfo"))
  : "";

const token = user ? user.data.token : "";

axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

export const viewCategoryList = (categoryData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_CATEGORY_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/category/list`,
        categoryData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_CATEGORY_LIST_SUCCESS", payload: data });
        dispatch({ type: "SET_FETCH_TIME", payload: Date.now() });
      } else {
        dispatch({ type: "GET_CATEGORY_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_CATEGORY_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addNewCategory = (categoryData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "ADD_CATEGORY_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/category/add`,
        categoryData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_CATEGORY_SUCCESS", payload: data });
        toast.success("Added Successfully!");
        return data;
      } else {
        dispatch({ type: "ADD_CATEGORY_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "ADD_CATEGORY_FAILED",
        payload: error?.response?.data,
      });
      toast.error(error?.response?.data?.message);
      return error?.response?.data?.message;
    }
  };
};

export const editCategory = (categoryData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "EDIT_CATEGORY_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/category/update`,
        categoryData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "EDIT_CATEGORY_SUCCESS", payload: data });
        toast.success("Edited Successfully!");
        return data;
      } else {
        dispatch({ type: "EDIT_CATEGORY_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "EDIT_CATEGORY_FAILED",
        payload: error?.response?.data?.message,
      });
      return error?.response?.data?.message;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewCategory = (categoryData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "VIEW_CATEGORY_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.get(
        `${BASE_URL}/category/${categoryData}`,
        categoryData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_CATEGORY_SUCCESS", payload: data });
 
        return data;
      } else {
        dispatch({ type: "VIEW_CATEGORY_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "VIEW_CATEGORY_FAILED",
        payload: error?.response?.data?.message,
      });
      return error?.response?.data?.message;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewSubCategoryList = (subCategoryData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_SUB_CATEGORIES_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/category/list`,
        subCategoryData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_SUB_CATEGORIES_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_SUB_CATEGORIES_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_SUB_CATEGORIES_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    }
  };
};
